/** Clients entry in the portal menu (wording kept with the module). */
export const CLIENTS_NAV = { label: "Clients", hint: "Accounts and welcome packs" } as const;
